import './styles.scss'

import PropTypes from 'prop-types'
import React from 'react'

const EXPANDED = {
  true: 'content',
  false: 'content collapsed'
}

export class Expandable extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      expanded: false
    }
    this.toggle = this.toggle.bind(this)
  }

  toggle () {
    this.setState(s => ({
      expanded: !s.expanded
    }))
  }

  render () {
    const { children, expandedHeight, title, greedy } = this.props
    const { expanded } = this.state

    return (
      <div
        className={`nh-expandable ${expanded && 'expanded'}`}
        style={{ height: expanded ? `${expandedHeight}px` : 'auto' }}
      >
        <div
          className='title'
          onClick={this.toggle}
          aria-hidden='true'
        >
          <span className='chevron-icon' />
          <span className='text'>{title}</span>
        </div>
        {(expanded || greedy) && <div className={EXPANDED[!!expanded]}>{children}</div>}
      </div>
    )
  }
}

Expandable.propTypes = {
  title: PropTypes.string.isRequired,
  expandedHeight: PropTypes.number
}
